import './App.css';
import Nav from './components/nav'

import MainContent from './components/mainContent'
import Layout from './components/layout'
import { useEffect } from "react";
function App() {
  useEffect(() => {
  }, []);
  return (
    <Layout>
    <Nav/>
    <MainContent/>
    </Layout>
  );
}

export default App;
